import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconWineDirect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={11} height={18} fill="none" {...props}>
    <path
      d="M5.684 10.838v6.139M3.552 16.977h4.264"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M1.066 6.404l.669-4.82a.35.35 0 0 1 .352-.296h7.194a.35.35 0 0 1 .355.296l.667 4.82c0 2.449-2.068 4.434-4.619 4.434-2.55 0-4.618-1.985-4.618-4.434z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.208 5.38h8.886"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconWineDirect;
